module.exports = __webpack_public_path__ + "static/img/M-6.3f59d19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mga/M-6.png
// module id = SMjT
// module chunks = 0